<template>
  <div class="selector-list" >
    <div class="search_input">
      <div class="vux-x-input weui_cell">
        <div class="weui_cell_hd"></div> 
        <div class="weui_cell_bd weui_cell_primary">
          <input type="text" placeholder="请输入姓名" class="weui_input" v-model="keyWord" @input="inputSearch">
        </div> 
        <div class="weui_cell_ft" @click.stop="valueSearch">
          <img src="data:image/png;base64,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" class="search_icon">
        </div>
      </div>
    </div>
    <div class="weui_cells_title">{{title}}</div> 
    <div class="weui_cells" v-if="roleNew.length > 0"> 
      <div class="weui_cell vux-tap-active"  v-for="(item, index) in roleNew"
          :key="index" @click="checkItem(item, index)">
        <div class="weui_cell_hd"></div> 
        <div class="weui_cell_bd weui_cell_primary">
          <p>{{item[nameKey]}}</p> 
          <span class="vux-label-desc">{{item[roleKey]}}</span>
          <input type="radio" name="selectorradio" :checked="item.ischecked"/>
          <i class="check_item_icon"></i>
        </div> 
      </div>
    </div>
    <div class="no-record" v-else>
      没有相关记录
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyWord: '',
      roleNew: []
    }
  },
  props: {
    title: {
      type: String,
      default: '请先让行政经理把门店人员添加到系统中'
    },
    nameKey: {
      type: String,
      default: 'name'
    },
    roleKey: {
      type: String,
      default: 'roles'
    },
    roleList: {
      type: Array,
      default: [],
      required: true
    }
  },
  created() {
    this.roleNew = this.roleList
  },
  watch: {
    roleList(val) {
      this.roleNew = val
    }
  },
  methods: {
    inputSearch() {
      if (this.keyWord === '') {
        // input为空,默认展示全部列表
        this.roleNew = this.roleList
      }
    },
    valueSearch() {
      let value = this.keyWord
      if (value) {
        this.roleNew = this.roleList.filter(v => {
          return v[this.nameKey].indexOf(value) > -1
        })
      }
    },
    checkItem(item, index) {
      // radio需要先清除默认选项
      this.roleList.forEach(v => {
        v.ischecked = false
      })
      item.ischecked = true
      this.$emit('check-item', item)
    }
  }
}
</script>
<style lang="less">
@import "../../styles/cui/base/fn";
.selector-parent{ position: relative;}
.selector-list {
  position: absolute; left: 0;top:0px; bottom: 0; right:0; background: #eee;
  input[type='radio']{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    opacity: 0;
  }
  input[type='radio'] + .check_item_input{ opacity: 0; position: relative; z-index: 11; width: 0.86rem;height: 0.96rem;
  }
   input[type='radio']:checked + .check_item_icon {
    background: #509eff;
    border: .08rem solid #fff;
    box-shadow: 0 0 0 1px #509eff;
 }
  .vux-label-desc{overflow: hidden;  text-overflow: ellipsis; white-space: nowrap; display: block;padding-right: 0.4rem;}
  .weui_cell_ft {width: 0.8rem;}
  .check_item_icon {
    position: absolute;
    right: .4rem;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: .45333333rem;
    height: .45333333rem;
    border: 1px solid #e7e7e7;
    border-radius: 50%;
    box-sizing: border-box;
}

  .weui_cell_primary{
    line-height: 24px;
     overflow: hidden;
  }
  .search_input .weui_input {
    line-height: .66666667rem;
  }
  .search_input {
      background-color: #eee;
      padding: .26666667rem .4rem;
      font-size: 15px;
      border-radius: .05333333rem;
  }.search_input .weui_cell {
      padding: .2rem .4rem;
      background-color: #fff;
  }
  .search_input .search_icon {
      width: .53333333rem;
      margin-bottom: -.13333333rem;
      margin-left: .13333333rem;
  }
  .weui_cells_title{padding-top: 0;}
  .no-record{
    margin: 0 auto;
    padding: 3.33333333rem 0 .66666667rem;
    text-align: center;
    color: #000;
    opacity: .4;
    font-size: .4rem;
  }
}
</style>



// WEBPACK FOOTER //
// selector-list.vue?bfe4fa44